import { ChatBotPage } from '@/Workspaces/ChatBot/ChatBotPage'
import { createFileRoute, useParams } from '@tanstack/react-router'

export const Route = createFileRoute('/workspace/$workspaceId/chatBotData/$chatBotDataId/chat')({
  component: RouteComponent,
})

function RouteComponent() {
  const { chatBotDataId } = useParams({ from: "/workspace/$workspaceId/chatBotData/$chatBotDataId/chat" })
  return <ChatBotPage chatBotId={chatBotDataId} />
}
